/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true, unparam: true */

"use strict";

var ko = require("knockout");

var $ = require("../jquery");
var pli = require("../core");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

var submenuShowTimeoutId = null,
    lastShownMenu = null,
    templatePrefix = "menu",
    showMenuEvent = $.Callbacks(), // fires when a menu has been opened
    hideMenuEvent = $.Callbacks(); // fires when a menu has been closed

//-------------------------------------------
// If any submenu show action is pending
// (e.g. when hovering over menu item
// with submenu), cancel it now.
function cancelPendingSubmenuShow() {
    if (submenuShowTimeoutId) {
        window.clearTimeout(submenuShowTimeoutId);
        submenuShowTimeoutId = null;
    }
}


//-------------------------------------------
// adds a template element into DOM if it doesn't exist
function ensureTemplate(id, template) {
    if ($('#' + id).length === 0) {
        var templateStr = (typeof template === "string"
            ? template
            : template.join(""));
        $("body").append("<script id=\"" + id + "\" type=\"text/html\">" + templateStr + "<\/script>");
    }
}


//-------------------------------------------
// Define built-in menu item templates and make
// sure they are injected into the current DOM.
function ensureMenuTemplates() {
    /*jslint white: true */

    // add menu knockout template
    ensureTemplate(
        templatePrefix.concat("Template"), [
        "<ul class='pliMenu' data-bind='",
            "template: { foreach: menuItems, name: function (menuItem) { return menuItem.templateId; } },",
            "visible: visible,",
            "style: { left: position().left + \"px\", top: position().top + \"px\" }",
        "'></ul>"]);

    // add button menu item knockout template
    ensureTemplate(
        templatePrefix.concat("Button"), [
        "<li class='pliMenuItem' data-bind='visible: visible'>",
            "<button class='pliMenuAction' data-bind='name: name, click: onClick, pliDisableButton: disabled, css: { pliActiveCmd: active }'>",
                "<!-- ko if: sprite --><i class='pliMenuIcon' data-bind='css: sprite'></i><!-- /ko -->",
                "<!-- ko if: hasSubmenu --><i class='pliMenuIcon arrow'></i><!-- /ko -->",
                "<!-- ko text: title --><!-- /ko -->",
            "</button>",
            "<!-- ko if: hasSubmenu --><div data-bind='template: { name: \"menuTemplate\", data: submenu }'></div><!-- /ko -->",
        "</li>"]);

    // add label menu item knockout template
    ensureTemplate(
        templatePrefix.concat("Label"), [
        "<li class='pliMenuItem' data-bind='visible: visible'>",
            "<div class='pliMenuLabel'>",
                "<!-- ko if: sprite --><i class='pliMenuIcon' data-bind='css: sprite'></i><!-- /ko -->",
                "<!-- ko text: title --><!-- /ko -->",
            "</div>",
        "</li>"]);

    // add error menu item knockout template
    ensureTemplate(
        templatePrefix.concat("Error"), [
        "<li class='pliMenuItem' data-bind='visible: visible'>",
            "<div class='pliMenuLabel error'>",
                "<i class='pliMenuIcon sprite-warning-16'></i>",
                "<!-- ko text: title --><!-- /ko -->",
            "</div>",
        "</li>"]);

    // add separator menu item knockout template
    ensureTemplate(
        templatePrefix.concat("Separator"),
        "<li class='pliMenuSeparator' data-bind='visible: visible'></li>");

    /*jslint white: false */
}


//-------------------------------------------
// For the specified positioning information
// (as created by "findBestFitOffsetFor")
// calculate candidate offsets, preferring
// horizontal positioning (target element
// appears to the left or right of the owner
// element). Suitable for submenus.
function getOffsetCandidatesWithHorizontalPreference(info) {
    var left1 = info.ownerOffset.left + info.ownerWidth;
    var left2 = info.ownerOffset.left - info.targetWidth + (info.ownerWidth ? 0 : 1); // if owner has no width, compensate by 1px
    var top2 = info.ownerOffset.top - (info.targetHeight - (info.ownerHeight || 1)); // if owner has no height, compensate by 1px
    return [
        { left: left1, top: info.ownerOffset.top }, // "to the right and align top edge"
        { left: left1, top: top2 }, // "to the right and align bottom edge"
        { left: left2, top: info.ownerOffset.top }, // "to the left and align top edge"
        { left: left2, top: top2 } // "to the left and align bottom edge"
    ];
}


//-------------------------------------------
// For the specified positioning information
// (as created by "findBestFitOffsetFor")
// calculate candidate offsets, preferring
// vertical positioning (target element
// appears above or below the owner element).
// Suitable for toolbar (fixed) menus.
function getOffsetCandidatesWithVerticalPreference(info) {
    var left2 = info.ownerOffset.left - (info.targetWidth - (info.ownerWidth || 1)); // if owner has no width, compensate by 1px
    var top1 = info.ownerOffset.top + info.ownerHeight;
    var top2 = info.ownerOffset.top - info.targetHeight + (info.ownerHeight ? 0 : 1); // if owner has no height, compensate by 1px
    return [
        { left: info.ownerOffset.left, top: top1 }, // "align left edge and below"
        { left: left2, top: top1 }, // "align right edge and below"
        { left: info.ownerOffset.left, top: top2 }, // "align left edge and above"
        { left: left2, top: top2 } // "align right edge and above"
    ];
}


//-------------------------------------------
// Find offset of top-left corner of target
// element (relative to target element's offset
// parent) that best fits in the current viewport.
//
// Terminology:
// "viewport" - client area of browser window;
//     assuming top-left corner is [0,0];
//     when document scrollbars are in their
//     initial position, viewport coordinates
//     match document coordinates; once scrollbars
//     move, the same viewport pixels show different
//     parts of the document, depending on current
//     scrollbar position)
// "target" - element being positioned
//     (e.g. context menu)
// "owner" - element next to which "target"
//     element will appear (usually button
//     that made "target" visible or mouse
//     right-click point)
function findBestFitOffsetFor($target, $targetOffsetParent, $ownerOrPositionEvent, getCandidates) {
    // determine viewport and target dimensions
    var $window = $(window);
    var info = {
        viewportWidth: $window.width(),
        viewportHeight: $window.height(),
        targetWidth: $target.outerWidth(),
        targetHeight: $target.outerHeight(),
        ownerWidth: 0,
        ownerHeight: 0,
        ownerOffset: null
    };

    // determine owner dimensions and offset,
    // adjusted to relative-to-viewport
    // coordinate system
    var $document = $(document),
        documentScrollLeft = $document.scrollLeft(),
        documentScrollTop = $document.scrollTop();
    if (typeof $ownerOrPositionEvent.offset === "function") {
        info.ownerWidth = $ownerOrPositionEvent.outerWidth();
        info.ownerHeight = $ownerOrPositionEvent.outerHeight();
        info.ownerOffset = $ownerOrPositionEvent.offset(); // relative-to-document (as per jQuery documentation)
        info.ownerOffset.left = info.ownerOffset.left - documentScrollLeft; // adjust to relative-to-viewport
        info.ownerOffset.top = info.ownerOffset.top - documentScrollTop; // adjust to relative-to-viewport
    } else {
        info.ownerOffset = {
            left: $ownerOrPositionEvent.pageX - documentScrollLeft, // adjust to relative-to-viewport
            top: $ownerOrPositionEvent.pageY - documentScrollTop // adjust to relative-to-viewport
        };
    }

    // get & evaluate candidates
    var i, l, selected, candidates = getCandidates(info);
    for (i = 0, l = candidates.length; i < l; i += 1) {
        selected = candidates[i];
        if (selected.left >= 0 && selected.top >= 0 && info.viewportWidth - (selected.left + info.targetWidth) >= 0 && info.viewportHeight - (selected.top + info.targetHeight) >= 0) {
            break;
        }
        selected = null;
    }
    if (!selected) {
        selected = candidates[0]; // if no candidate fits, use the first one
    }

    // adjust selected candidate offset from relative-to-viewport
    // to relative-to-target's-offset-parent coordinate system
    var targetOffsetParentOffset = ($targetOffsetParent ? $targetOffsetParent.offset() : { left: 0, top: 0 }); // relative-to-document (as per jQuery documentation)
    targetOffsetParentOffset.left = targetOffsetParentOffset.left - documentScrollLeft; // adjust to relative-to-viewport
    targetOffsetParentOffset.top = targetOffsetParentOffset.top - documentScrollTop; // adjust to relative-to-viewport
    selected.left = selected.left - targetOffsetParentOffset.left; // convert to relative-to-target's-offset-parent
    selected.top = selected.top - targetOffsetParentOffset.top; // convert to relative-to-target's-offset-parent
    return selected;
}


//-------------------------------------------
// calculates position of static (non-context) menu
function getStaticMenuPosition($triggerElement, $menuElement) {
    return findBestFitOffsetFor($menuElement, null, $triggerElement, getOffsetCandidatesWithVerticalPreference);
}


//-------------------------------------------
// calculates position of context menu
function getContextMenuPosition(e, $menuElement) {
    return findBestFitOffsetFor($menuElement, null, e, getOffsetCandidatesWithHorizontalPreference);
}


//-------------------------------------------
// Calculate submenu position. Assumes that
// submenu positioning container is
// the specified "menuItemElement".
function getSubmenuPosition($menuItemElement) {
    return findBestFitOffsetFor($menuItemElement.find(".pliMenu"), $menuItemElement, $menuItemElement, getOffsetCandidatesWithHorizontalPreference);
}


//-------------------------------------------
// Handle recognized mouse events on menu items.
// Currently shows/hides submenus when mouse
// hovers over menu items.
function onMenuItemMouseEvent(e) {
    // determine action(s) to take
    var cancel = false;
    var menuItemToShow = null;
    switch (e.type) {
    case "mouseenter":
        menuItemToShow = ko.dataFor(e.target);
        if (menuItemToShow && !menuItemToShow.parentMenu) { menuItemToShow = menuItemToShow.parentMenuItem; } // if event bubbled from element associted with submenu viewmodel, select MenuItem that showed that submenu
        cancel = !!menuItemToShow;
        break;
    case "mouseleave": // cancel pending menu show
        cancel = true;
        break;
    }

    // run cancel action if needed
    if (cancel) {
        cancelPendingSubmenuShow();
    }

    // run show action if needed
    if (menuItemToShow) {
        menuItemToShow.parentMenu.updateActiveItems(); // make all items inactive on current menu
        submenuShowTimeoutId = window.setTimeout(function () {
            if (menuItemToShow.hasSubmenu()) {
                menuItemToShow.showSubmenu(e);
            } else {
                menuItemToShow.parentMenu.hideSubmenusRecursive();
            }
        }, 500);
    }
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// MenuItem class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// menu item view model
function MenuItem(config, data, parent, MenuClass) {
    this.config = config;
    this.parentMenu = parent;
    this.data = data;
    this.templateId = templatePrefix.concat(data.type || "Button");
    this.title = ko.observable(data.title || "");
    this.name = ko.observable(data.name || "");
    this.items = ko.observableArray(data.items);
    this.visible = ko.observable(true);
    this.disabled = ko.observable(!!data.disabled);
    this.active = ko.observable(false);
    this.sprite = ko.observable(data.sprite || "");
    this.submenu = ko.observable(null);
    this.hasSubmenu = ko.observable();

    // handle submenu item changes
    ko.computed(function () {
        var items = this.items();
        if (items && items.length) {
            this.submenu(new MenuClass(this.config, items, this));
            this.hasSubmenu(true);
        } else {
            this.submenu(null);
            this.hasSubmenu(false);
        }
    }, this);
}


//-------------------------------------------
// shows submenu
MenuItem.prototype.showSubmenu = function menuItemShowSubmenu(e) {
    cancelPendingSubmenuShow();
    this.parentMenu.hideSubmenusRecursive();
    if (this.disabled.peek()) { return; }
    this.submenu().showMenuStrip(getSubmenuPosition($(e.target).closest("li")));
};


//-------------------------------------------
// handles menu item click event
MenuItem.prototype.onClick = function menuItemOnClick(item, e) {
    if (this.hasSubmenu()) {
        this.showSubmenu(e);
    } else {
        this.parentMenu.hideRoot();
        // execute click handler
        (this.data.click || this.config.click)(this, this.parentMenu.getRoot().currentContext, e);
    }
    e.stopPropagation();
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Menu class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// menu view model
function Menu(config, items, parent) {
    this.parentMenuItem = parent;
    this.currentContext = null;
    this.config = config;
    this.visible = ko.observable(false);
    this.items = ko.observableArray(items || []); // raw items
    this.menuItems = ko.computed(Menu.prototype.getMenuItems, this);
    this.position = ko.observable({ left: 0, top: 0 });
}


//-------------------------------------------
// converts raw items into array of MenuItem objects
Menu.prototype.getMenuItems = function menuGetMenuItems() {
    var menuItems = [], i, l = this.items().length;
    for (i = 0; i < l; i += 1) {
        menuItems.push(new MenuItem(this.config, this.items()[i], this, Menu));
    }
    return menuItems;
};


//-------------------------------------------
// return root menu
Menu.prototype.getRoot = function menuGetRoot() {
    var root = this;
    while (root.parentMenuItem) {
        root = root.parentMenuItem.parentMenu;
    }
    return root;
};


//-------------------------------------------
// highlights active menu items only
Menu.prototype.updateActiveItems = function menuUpdateActiveItems() {
    // make all parent menu items active
    var parentMenu = this;
    while (parentMenu.parentMenuItem) {
        parentMenu.parentMenuItem.active(true);
        parentMenu = parentMenu.parentMenuItem.parentMenu;
    }
    // make all menu items on current menu inactive
    $.each(this.menuItems(), function (i, mi) {
        mi.active(false);
    });
};


//-------------------------------------------
// Shows menu element at given position.
// The function loads menu items from server if there is need.
// NOTE: position is passed as resolver function to
// make it possible to recalculate position of
// changed menu when it loads items from server
Menu.prototype.show = function menuShow(positionResolver) {
    // request menu items if there is call data and this is top level menu
    if (this.config.itemsCallData && !this.parentMenuItem) {
        // show loading message
        this.items([{ type: "Label", title: "Loading...", sprite: "sprite-progress-15 sprite-spin" }]);

        // do call to get menu items
        var callData = this.config.itemsCallData(this.getRoot().currentContext);
        callData.owner = this;
        this.activeRequest = pli.call(callData);
        this.activeRequest.always(function completeMenuItemsLoad(response) {
            var menu = response.owner;
            if (menu.activeRequest && menu.activeRequest.xhr === response.clientXhr) {
                var menuItems;
                if (response.isError) {
                    if (window.console) { window.console.error("Failed to get menu items: ".concat(response.result.message), response); }

                    menuItems = [
                        { type: "Error", title: "Unable to load" },
                        {
                            title: "Reload",
                            sprite: "sprite-refresh-16",
                            click: function retryMenuItemsLoad() {
                                menu.show(positionResolver);
                                return false;
                            }
                        }
                    ];
                } else {
                    menuItems = response.result;
                }

                menu.activeRequest = null;
                menu.items(menuItems);
                menu.position(positionResolver()); // show menu again with recalculated position because menu size's been changed
            } // else { if (window.console) { window.console.warn("This get-menu-items server response is stale, ignoring", response); } }
        });
    }

    this.showMenuStrip(positionResolver());
};


//-------------------------------------------
// Makes menu visible if it has items
Menu.prototype.showMenuStrip = function showMenuStrip(position) {
    // show menu only when menu is not empty
    if (this.menuItems().length > 0) {

        // track last shown menu
        lastShownMenu = this;

        // reset active items and make parent menu item active
        this.updateActiveItems();

        // resolve new position
        this.position(position);

        // position and make menu visible
        this.visible(true);

        // notify subscribers about shown menu
        showMenuEvent.fire(this);
    }
};


//-------------------------------------------
// hides menu, its submenus and cancels active request if there is one
Menu.prototype.hide = function menuHide() {
    this.activeRequest = null;
    if (this.visible()) {
        this.hideSubmenusRecursive();
        this.visible(false);
        hideMenuEvent.fire(this);
    }
};


//-------------------------------------------
// calls hide() method on root menu
Menu.prototype.hideRoot = function menuHideRoot() {
    this.getRoot().hide();
};


//-------------------------------------------
// hides all submenus recursively
Menu.prototype.hideSubmenusRecursive = function menuHideSubmenusRecursive() {
    // hides all submenus from given menu level
    $.each(this.menuItems(), function (i, mi) {
        if (mi.hasSubmenu()) {
            mi.submenu().hideSubmenusRecursive();
            mi.submenu().hide();
        }
    });
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function setup(config) {
    // expected config members:
    //   clickSelector - jQuery element that is going to be clicked to make menu appeared
    //   rightClickSelector - jQuery element that is going to be right clicked make menu appeared
    //   notifier - callback that's triggered when there is need to display menu
    //   itemsCallData - call data to get menu items
    //   items - menu items hierarchy:
    //      title - display text
    //      html - custom html
    //      name - name
    //      visible - visibility
    //      type - Button, Label, Separator, Error or Custom
    //      disabled
    //      sprite - sprite CSS class
    //      items - submenu items
    //      click - custom menu item click handler
    //   click - general menu items click handler

    if (!config.clickSelector && !config.rightClickSelector && !config.notifier) {
        throw new Error("Menu cannot be created because there is no information specified when to show one.");
    }

    // ensure menu templates are defined
    ensureMenuTemplates();

    // create & configure menu container
    var emptyHandler = function () { return false; };
    var $container = $("<!-- ko stopBinding: true --><div data-bind='template: { name: \"menuTemplate\" }'></div><!-- /ko -->").appendTo("body");
    $container[1].oncontextmenu = emptyHandler; // disable default context menu for the menu element
    $container.eq(1).on("mouseenter mouseleave", ".pliMenu > *", onMenuItemMouseEvent);

    // create & bind menu viewmodel
    if (!config.click) { config.click = emptyHandler; }
    var menu = new Menu({ itemsCallData: config.itemsCallData, click: config.click }, config.items);
    ko.applyBindings(menu, $container[1]);

    // container is now populated with menu, so let's resolve its element
    var $menuElement = $container.find(".pliMenu").first();

    // handle right click selector
    if (config.rightClickSelector) {
        var $rightClickSelector = $(config.rightClickSelector);
        $rightClickSelector[0].oncontextmenu = emptyHandler;
        $rightClickSelector.on("mouseup", function (e) {
            if (e.which === 3) { // right click
                menu.currentContext = config.rightClickSelector;
                menu.show(function () {
                    return getContextMenuPosition(e, $menuElement);
                });
            }
        });
    }

    // handle click selector
    if (config.clickSelector) {
        var $clickSelector = $(config.clickSelector);
        $clickSelector.on("click", function () {
            // NOTE: hack to make toolbar item active depending on whether its menu shown or not
            showMenuEvent.add(function (sender) {
                if (sender === menu) { $clickSelector.addClass("pliActiveCmd"); }
            });
            hideMenuEvent.add(function (sender) {
                if (sender === menu) { $clickSelector.removeClass("pliActiveCmd"); }
            });

            menu.currentContext = $clickSelector;
            menu.show(function () {
                return getStaticMenuPosition($clickSelector, $menuElement);
            });
        });
    }

    // handle notifier
    if (config.notifier) {
        config.notifier.add(function (e, context) {
            menu.currentContext = context;
            menu.show(function () {
                return getContextMenuPosition(e, $menuElement);
            });
        });
    }

    // handle document mousedown event to hide this menu and all its submenus
    $(window.document).mousedown(function (e) {
        // hide menu only when mousedown occured outside
        if (!$container.has($(e.target)).length) {
            menu.hide();
        }
    });

    // resizing browser window will hide all active menus
    $(window).resize(function () {
        menu.hide();
    });

    // activate menu keymap on menu show, deactivate on hide
    showMenuEvent.add(function menuActivateKeymap(shownMenu) {
        if (shownMenu === menu) {
            pli.keys.activateKeymap("pliMenu");
        }
    });
    hideMenuEvent.add(function menuDeactivateKeymap(hiddenMenu) {
        if (hiddenMenu === menu) {
            pli.keys.deactivateKeymap("pliMenu");
        }
    });

    // return menu view model
    return menu;
}

if (!pli.keys) { throw new Error('Menu.js expects a PliKeys instance on "pli.keys" but none was found'); }

// register a menu keymap (will be activated
// when main menu is shown, deactivated when
// main menu is hidden)
pli.keys.registerKeymap("pliMenu", {
    "Esc": function closeLastShownMenu() {
        if (lastShownMenu) {
            lastShownMenu.hide();
            lastShownMenu = (lastShownMenu.parentMenuItem && lastShownMenu.parentMenuItem.parentMenu) || null;
            return false;
        }
    }
});


// exported as "Pli.menu"
module.exports = {
    setup: setup,
    templatePrefix: templatePrefix,

    // export offset calculation from menu module for now
    // (this is a good candidate for separate module in the future)
    findBestFitOffsetFor: findBestFitOffsetFor,
    getOffsetCandidatesWithHorizontalPreference: getOffsetCandidatesWithHorizontalPreference,
    getOffsetCandidatesWithVerticalPreference: getOffsetCandidatesWithVerticalPreference
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms/Menu.js
// module id = 389
// module chunks = 49